export const RELAY_ERROR = 499;
export const NOT_FOUND_ERROR = 404;